import _ from 'lodash'
import {setAccessToken} from "../../Services/auth";

const authLocalStorageName = 'WebAuth'
const authImpersonationStorageName = 'WebAuth_Impersonation'

export const calcAndGetTokenFromLogin = (loginData, decodedToken) => {
    let token;
    if (decodedToken) {
        token = decodedToken
    }
    else if (loginData) {
        token = getDecodedToken(_.get(loginData, 'token'))
    }
    return token
}

export const setUserState = ({user, token}) => {
    saveUserStateToLocalStorage({user, token})
    setAccessToken(getDecodedToken(token))
    console.log('setting token')
}

export const saveUserStateToLocalStorage = ({user, token}) => {
    const userStateToSave = {user, token}
    
    // Use separate localStorage key for super admin impersonation sessions
    // This allows both super admin and impersonated user sessions to coexist
    const storageKey = user && user.isSuperAdminLogin
        ? authImpersonationStorageName
        : authLocalStorageName

    typeof window !== undefined && window.localStorage.setItem(storageKey, JSON.stringify(userStateToSave))
}

export const loadUserStateFromLocalStorage = () => {
    // Prioritize impersonation session if it exists
    // This allows super admin to stay logged in while impersonating users
    const impersonationState = typeof window !== undefined && window.localStorage.getItem(authImpersonationStorageName);
    if (impersonationState) {
        return JSON.parse(impersonationState);
    }

    // Fall back to regular auth session
    const userState = typeof window !== undefined && window.localStorage.getItem(authLocalStorageName);
    if (userState) {
        return JSON.parse(userState);
    }

    return emptyLoginStateFromLocalStorage();
};


export const emptyLoginStateFromLocalStorage = () => {
    // Clear both regular and impersonation sessions
    typeof window !== undefined && window.localStorage.removeItem(authLocalStorageName);
    typeof window !== undefined && window.localStorage.removeItem(authImpersonationStorageName);
    return null
};

/**
 * Exits impersonation session and preserves super admin session
 * Only removes the impersonation key, keeping WebAuth intact
 * Use this when logging out from an impersonated user to return to super admin
 */
export const exitImpersonationSession = () => {
    if (typeof window !== undefined) {
        window.localStorage.removeItem(authImpersonationStorageName);
        // authLocalStorageName (WebAuth) remains intact - super admin session preserved
    }
};

export const getDecodedToken = (token) => {

    if (token) {
        token = token.replace("Bearer ", "");
        return "Bearer " + token
    }
    else return ''
};